import React from "react"
import { graphql } from 'gatsby'

import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/Hero"
import Ekibimiz from "../components/Ekibimiz"

const KurumsalPage = ({ data: { desktopImage, mobileImage } }) => (
  <Layout>
    <SEO
      title="Kurumsal | Konya İnşaat | İnşaat"
      description="İnşaat firmamız kurulduğu günden bu yana müşterilerine daha iyi hizmet verme amacında olup, altyapısını ve kalite anlayışı geliştirmekte."
    />
    <Hero
      title="Konya Ayazsan İnşaat Kurumsal"
      subtitle="Biz Kimiz?"
      text="İş disiplini ve kalite anlayışı ile kısa sürede müşterilerinin beğenisini kazanan Ayazsan İnşaat, malzeme teminini ve uygulama hizmetlerini her geçen gün geliştirerek sürdürmekte, sektörde daima ilerlemeyi ve iş kalitesini devamlı artırmayı amaçlamaktadır.
      "
      desktop={desktopImage.childImageSharp.fluid}
      mobile={mobileImage.childImageSharp.fluid} />
    <Ekibimiz />
  </Layout>
)

export const homeQuery = graphql`
{
  desktopImage: file(relativePath: { eq: "kurumsal.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 1200) {
        ...GatsbyImageSharpFluid_noBase64
      }
    }
  }
  mobileImage: file(relativePath: { eq: "kurumsal-cm.jpg" }) {
    childImageSharp {
      fluid(maxWidth: 500) {
        ...GatsbyImageSharpFluid_noBase64
      }
    }
  }
}
`

export default KurumsalPage
